export default __webpack_public_path__ + "static/media/CardImage4.052311ba.png";